import { render, staticRenderFns } from "./ModalSwitchCustomer.vue?vue&type=template&id=36410f3a&scoped=true"
import script from "./ModalSwitchCustomer.vue?vue&type=script&lang=js"
export * from "./ModalSwitchCustomer.vue?vue&type=script&lang=js"
import style0 from "./ModalSwitchCustomer.vue?vue&type=style&index=0&id=36410f3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36410f3a",
  null
  
)

export default component.exports